import classes from './Support.module.css';
import SubSectionWrapper from '@/components/layouts/AppShell/PatientProfileDrawer/SubSectionWrapper/SubSectionWrapper';
import SupportContactCard from './SupportContactCard';
import useSupportInfo from '@/hooks/useSupportInfo';

interface SupportProps {
  onGoBack: () => void;
}

export const Support = ({ onGoBack }: SupportProps) => {
  const { supportEmail } = useSupportInfo();

  return (
    <SubSectionWrapper title="Support" onGoBack={onGoBack}>
      <ul className={classes.unorderedList}>
        <li>
          <SupportContactCard email={supportEmail} title="Technical Support" />
        </li>
      </ul>
    </SubSectionWrapper>
  );
};
